import { useState } from 'react';

/**
 * Picking the friend. The send only works if that person would answer, so the
 * line over the box steers toward somebody who will add to it. Two tries at
 * prompting harder (superlative cards, then relationship chips) both came out
 * (owner, 2026-10-02): people already know who they mean, so it is just the box.
 */
export function FriendPick({ value, onChange, label, talk }: { value: string; onChange: (v: string) => void; label?: string; talk: boolean }) {
  const [focused, setFocused] = useState(false);
  return (
    <div className="friend-pick">
      <div className="stack" style={{ gap: 2 }}>
        <span className="label">Who comes to mind?</span>
        <p className="why">{talk ? 'A story comes easier with somebody who will add to it.' : 'This works best with somebody who will play along.'}</p>
      </div>
      <div className="field">
        <label htmlFor="friend">{label || 'Their first name'}</label>
        <input id="friend" className="input" value={value} onChange={(ev) => onChange(ev.target.value)} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
          placeholder="Maya" autoComplete="off" enterKeyHint="done" />
        {(focused || value) && <span className="hint">{talk ? 'So the story has their name. You decide whether to send it, after.' : 'So the prompt has their name.'}</span>}
      </div>
    </div>
  );
}
